import { Component, type ComponentType } from "react";
import GoogleAnalytics from "react-ga4";

// Make sure that `withTracker HOC is applied among with `withRouter` that provides required props
const withTracker = <P extends { location: Location }>(
  WrappedComponent: ComponentType<P>
) => {
  const gaApiKey = import.meta.env.VITE_GA_API_KEY;

  const trackPage = (page: string) => {
    GoogleAnalytics.event("page_view", {
      page,
    });
  };

  class HOC extends Component<P> {
    componentDidMount() {
      const page = window.location.pathname + window.location.search;
      trackPage(page);
    }

    componentDidUpdate(prevProps: P) {
      const { pathname, search } = this.props.location;
      const { pathname: prevPathname, search: prevSearch } = prevProps.location;

      const currentPage = prevPathname + prevSearch;
      const nextPage = pathname + search;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return gaApiKey ? HOC : WrappedComponent;
};

export default withTracker;
